export default "__VITE_ASSET__CXDVUHaW__"